import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router';
import { scrubCredentials } from './sentryScrubbing';

export interface SentryOptions {
    enabled: boolean;
    dsn: string | undefined;
    sendDefaultPii: boolean;
    environment: string | undefined;
    debug: boolean;
    release: string;
    tracesSampleRate: number;
}

// @ai-generated 2026-10-29T10:59:52+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
/** Starts Sentry with react-router tracing and credential scrubbing. Returns undefined when disabled. */
export function initSentry({
    enabled,
    dsn,
    sendDefaultPii,
    environment,
    debug,
    release,
    tracesSampleRate,
}: SentryOptions) {
    if (!enabled) {
        return undefined;
    }

    return Sentry.init({
        enabled,
        dsn,
        sendDefaultPii,
        environment,
        debug,
        release,
        integrations: [
            Sentry.reactRouterV7BrowserTracingIntegration({
                useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
            Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
        ],
        tracePropagationTargets: [/^\/api/, 'localhost'],
        tracesSampleRate,
        enableLogs: true,
        beforeSend: scrubCredentials,
        beforeSendTransaction: scrubCredentials,
        beforeSendSpan: scrubCredentials,
        beforeBreadcrumb: scrubCredentials,
        beforeSendLog: scrubCredentials,
    });
}
